import { useEffect, useRef } from 'react'

type TurnstileWidgetProps = {
  siteKey: string
  onTokenChange: (token: string) => void
  resetNonce: number
}

const TURNSTILE_SCRIPT_ID = 'cloudflare-turnstile-api'

function ensureTurnstileScript() {
  if (document.getElementById(TURNSTILE_SCRIPT_ID)) return
  const script = document.createElement('script')
  script.id = TURNSTILE_SCRIPT_ID
  script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
  script.async = true
  script.defer = true
  document.head.appendChild(script)
}

export function TurnstileWidget({ siteKey, onTokenChange, resetNonce }: TurnstileWidgetProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const widgetIdRef = useRef<string | null>(null)

  useEffect(() => {
    ensureTurnstileScript()
    let cancelled = false
    let timer: number | undefined

    const render = () => {
      if (cancelled || !containerRef.current) return
      if (!window.turnstile) {
        timer = window.setTimeout(render, 100)
        return
      }
      if (widgetIdRef.current) return

      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: siteKey,
        action: 'lead-request',
        theme: 'light',
        callback: onTokenChange,
        'expired-callback': () => onTokenChange(''),
        'error-callback': () => onTokenChange(''),
      })
    }

    render()
    return () => {
      cancelled = true
      if (timer) window.clearTimeout(timer)
      if (widgetIdRef.current && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current)
      }
      widgetIdRef.current = null
    }
  }, [siteKey, onTokenChange])

  useEffect(() => {
    if (widgetIdRef.current && window.turnstile) {
      onTokenChange('')
      window.turnstile.reset(widgetIdRef.current)
    }
  }, [resetNonce, onTokenChange])

  return <div className="quote-flow__turnstile" ref={containerRef} aria-label="Verificación de la solicitud" />
}
